module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "sec5"
    }
  }), _vm._v("Untitled # 70 (Or, The Question of Remains)")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The day she put on her glitz teardrops"), _c('br'), _vm._v("and O Hon lip gloss,"), _c('br'), _vm._v("ate an orange on an empty"), _c('br'), _vm._v("and took the 8-train"), _c('br'), _vm._v("to Grackleville, she met a man"), _c('br'), _vm._v("climbing a narrow stairwell,"), _c('br'), _vm._v("repeating to himself, This is all, this is all."), _c('br'), _vm._v("The music of a popular march played"), _c('br'), _vm._v("in his head. This, he said, is all,"), _c('br'), _vm._v("directing any further comment"), _c('br'), _vm._v("to a longtime opposition blooming in his chest."), _c('br'), _vm._v("No, he said, to the offer"), _c('br'), _vm._v("of a chaotic labyrinth of clouds,"), _c('br'), _vm._v("devotion, rain, creatures of fables,"), _c('br'), _vm._v("and opulent solitude."), _c('br'), _vm._v("Alone he entered the thicket"), _c('br'), _vm._v("of empty situations, the rhetorical force"), _c('br'), _vm._v("of conversation,"), _c('br'), _vm._v("muttering as he went, This is all—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Apprentice to death. Toxic grace."), _c('br'), _vm._v("Terrible and beautiful repose."), _c('br'), _vm._v("Dismay and murkiest waters."), _c('br'), _vm._v("The blighted morning."), _c('br'), _vm._v("The coordinate night."), _c('br'), _vm._v("The sad fact of the pink glow"), _c('br'), _vm._v("of Grackleville’s late iridescence.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4fb976","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_b.vue
// module id = 90
// module chunks = 0